import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import { DialogOverlay, DialogContent } from '@reach/dialog'
import styles from './Dialog.module.scss'
import { Icon } from 'components/Icon'

type DialogProps = {
  isOpen: boolean
  onClose: () => void
  'aria-label': string
  className?: string
}

export const Dialog: FC<DialogProps> = ({
  children,
  isOpen = true,
  onClose,
  className,
  ...rest
}) => {
  const { t } = useTranslation()

  return (
    <DialogOverlay isOpen={isOpen} onDismiss={onClose} className={styles.dialogOverlay}>
      <DialogContent className={cx(styles.dialogContent, className)} {...rest}>
        <button
          className={styles.dialogCloseButton}
          onClick={onClose}
          aria-label={t('common.close')}
        >
          <Icon name="close-line" />
        </button>
        {children}
      </DialogContent>
    </DialogOverlay>
  )
}

Dialog.displayName = 'Dialog'
